// @ts-nocheck
if (!customElements.get('swym-wishlist-popup')) {
  class SwymWishlistPopup extends HTMLElement {
    constructor() {
      super();
      this._initializeSwymComponent();
    }

    _initializeSwymComponent() {
      // Loaded on demand by swym-wishlist-button.js, normally after the SDK is ready, when a
      // SwymCallbacks entry may never run.
      if (window._swat) {
        this._init(window._swat);
        return;
      }
      if (!window.SwymCallbacks) window.SwymCallbacks = [];
      window.SwymCallbacks.push(this._init.bind(this));
    }

    _init(swat) {
      this._initializeSelectors();
      this._attachEventListeners();
    }

    async _initializeSelectors() {
      this.body = document.body;
      this.popup = this;
      this.closeBtn = this.querySelector('#swymcs-close-wishlist-popup');
      this.popupTitle = this.querySelector('#swymcs-wishlist-popup-product-title');
      this.popupImage = this.querySelector('#swymcs-wishlist-popup-product-image');
      this.createListBtn = this.querySelector('#swymcs-create-list-button');
      this.cancelCreateListBtn = this.querySelector('#swymcs-cancel-list-button');
      this.saveNewListBtn = this.querySelector('#swymcs-save-new-list-button');
      this.saveListBtn = this.querySelector('#swymcs-save-list-button');
      this.listsContainer = this.querySelector('#swymcs-wishlist-lists');
      this.createListContainer = this.querySelector('#swymcs-create-list-container');
      this.createListTextField = this.querySelector('#swymcs-create-list-field');
      this.createListError = this.querySelector('#swymcs-create-list-error');
      this.createListImagetext = this.querySelector('#swymcs-create-list-image-text');
      this.defaultListTilte = 'Saved List';
      this.globalActionArray = [];
      this.errorStrings = {
        emptyString: "{{ 'List name required' }}",
        shortString: "{{ 'Min. 3 characters required' }}",
        listLimitString:
          "{{ 'List limit of 10 Wishlists reached, please delete a wishlist to create newer wishlists.' }}",
        sameListString: "{{ ' already exists! Please enter a unique name.' }}",
      };
    }

    _attachEventListeners() {
      this.body.addEventListener('click', this._overlayEvent.bind(this));
      if (this.closeBtn) this.closeBtn.addEventListener('click', this._hide.bind(this));
      if (this.createListBtn) this.createListBtn.addEventListener('click', this._showCreateList.bind(this));
      if (this.cancelCreateListBtn) this.cancelCreateListBtn.addEventListener('click', this._hideCreateList.bind(this));
      if (this.saveListBtn) this.saveListBtn.addEventListener('click', this._saveList.bind(this));
      if (this.saveNewListBtn) this.saveNewListBtn.addEventListener('click', this._validateForm.bind(this));
      if (this.createListTextField) this.createListTextField.addEventListener('input', this._validateField.bind(this));
      
      if (this.listsContainer) {
        this.listsContainer.addEventListener('change', (evt) => {
          if (evt.target && evt.target.matches('input[type="checkbox"]')) {
            this._updateListHandler();
          }
        });
      }
    }

    _overlayEvent(evt) {
      if (evt.target.classList.contains('no-scroll')) this._hide();
    }

    _show(retryCount = 0) {
      if (this.popup) {
        this.popup.classList.add('swym-active-popup');
        this.body.classList.add('no-scroll');
        this._createHeader();
        this._renderLists();
        this._showContainer(this.popup);
        return; 
      }

      if (retryCount < 10) {
        setTimeout(() => {
          this.popup = this.querySelector('#swymcs-wishlist-popup') || this; 
          this._show(retryCount + 1);
        }, 50);
      } else {
        console.error("Swym Wishlist Popup internal HTML failed to render.");
      }
    }

    _hide() {
      this._hideContainer(this);
      this._hideCreateList();
      this.classList.remove('swym-active-popup');
      this.body.classList.remove('no-scroll');
      if (this.listsContainer) this.listsContainer.innerHTML = '';
      if (this.createListTextField) this.createListTextField.value = '';
      if (this.createListError) this.createListError.textContent = '';
      this.globalActionArray = [];
    }

    _showContainer(selector) {
      if (selector) selector.classList.remove('swym-hide-container');
    }

    _hideContainer(selector) {
      if (selector) selector.classList.add('swym-hide-container');
    }

    _updateListHandler() {
      let listInputs = this.listsContainer.querySelectorAll('input[type="checkbox"]');
      this.globalActionArray = [];

      listInputs.forEach((input) => {
        const lid = input.getAttribute('data-lid');
        const wasOriginallyAdded = input.classList.contains('swym-added-custom');
        
        if (!input.checked && wasOriginallyAdded) {
          this.globalActionArray.push({
            actionType: 'remove',
            listId: lid,
          });
        } else if (input.checked && !wasOriginallyAdded) {
          this.globalActionArray.push({
            actionType: 'add',
            listId: lid,
          });
        }
      });

      this._toggleWishlistButtonState();
    }

    _toggleWishlistButtonState() {
      if (this.globalActionArray.length === 0) {
        this.saveListBtn.setAttribute('disabled', 'true');
        this.saveListBtn.textContent = 'Select Lists';
      } else {
        const hasRemoveAction = this.globalActionArray.some((action) => action.actionType === 'remove');
        const hasAddAction = this.globalActionArray.some((action) => action.actionType === 'add');
        
        this.saveListBtn.removeAttribute('disabled');
        
        if (hasRemoveAction && !hasAddAction) {
          this.saveListBtn.textContent = 'Remove from Lists';
        } else if (hasRemoveAction && hasAddAction) {
          this.saveListBtn.textContent = 'Update Lists';
        } else {
          this.saveListBtn.textContent = 'Add to Lists';
        }
      }
    }

    _showLoadingState() {
      this._showContainer(this.listsContainer);
      this.listsContainer.innerHTML = `
        <div class="swymcs-loader-wrapper">
          <div class="swymcs-spinner"></div>
        </div>
      `;
    }

    _showCreateList() {
      this.createListTextField.placeholder = `${this.defaultListTilte} ${this.lists ? this.lists.length + 1 : 1}`;
      this.createListTextField.focus();
      this._showContainer(this.createListContainer);
      this._hideContainer(this.createListBtn);
      this._showContainer(this.cancelCreateListBtn);
      this._hideContainer(this.listsContainer);
      this._hideContainer(this.saveListBtn);
      this._showContainer(this.saveNewListBtn);
    }

    _hideCreateList() {
      this._hideContainer(this.createListContainer);
      this._hideContainer(this.cancelCreateListBtn);
      this._showContainer(this.createListBtn);
      this._showContainer(this.listsContainer);
      this._showContainer(this.saveListBtn);
      this._hideContainer(this.saveNewListBtn);
    }

    _createHeader() {
      if (this.popupImage) {
        this.popupImage.src =
          window.currentActiveProduct?.featured_image || window.currentActiveVariant?.featured_image?.src || '';
      }
      if (this.popupTitle) {
        this.popupTitle.textContent = window.currentActiveProduct?.title || '';
      }
    }

    async _renderLists() {
      this._showLoadingState();
      this.lists = await this._getLists();
      this.lists.length ? this._renderListsContainer() : this._showCreateList();
    }

    _renderListsContainer() {
      const activeVariantId = String(window.currentActiveVariantId || window.currentActiveProduct?.id || '');
      const activeProductId = String(window.currentActiveProduct?.id || '');

      let html = ``;
      const sortedLists = this.lists.sort((a, b) => b.uts - a.uts);

      sortedLists.forEach((list) => {
        const imageHtml = list.listcontents && list.listcontents.length
          ? `<img src="${list.listcontents[0].iu}" alt="${list.lname}">`
          : `<span class="swymcs-list-item-image-text">${list.lname[0]}</span>`;

        const isVariantInList = list.listcontents && list.listcontents.some((item) => {
          const itemEpi = String(item.epi || item.variantId || '');
          const itemEmpi = String(item.empi || item.productId || '');
          return (itemEpi === activeVariantId) || (itemEmpi === activeProductId && activeProductId !== '');
        });

        const isChecked = isVariantInList ? 'checked' : '';
        html += `
          <li class="swymcs-wishlist-select-lists">
            <input type="checkbox" class="${isVariantInList ? 'swym-added-custom' : ''}" data-lid="${list.lid}" ${isChecked} id="swymcs-wishlist-checkbox--${list.lid}"/>
            <label class="swymcs-buttons-container swymcs-button swymcs-popup-button swymcs-select-list" for="swymcs-wishlist-checkbox--${list.lid}" aria-label="${list.lname}">
              ${imageHtml}
              <div class="swymcs-wishlist-title">${list.lname}</div>
            </label>
          </li>
        `;
      });

      this.listsContainer.innerHTML = html;
      this._updateListHandler();
    }

    _getLists() {
      return new Promise((resolve, reject) => {
        window._swat.fetchLists({
          callbackFn: (lists) => resolve(lists || []),
          errorFn: (err) => reject(err),
        });
      });
    }

    // Strips internal server metadata keys that trigger 400 schema validation errors
    _cleanProductPayload(rawProduct) {
      if (!rawProduct) return {};
      
      // Clean target payload strictly containing accepted Swym schema keys
      const cleanPayload = {
        epi: Number(rawProduct.epi || window.currentActiveVariantId),
        empi: Number(rawProduct.empi || window.currentActiveProduct?.id),
        du: rawProduct.du || window.currentActiveProduct?.url || '',
      };

      if (rawProduct.dt || window.currentActiveProduct?.title) {
        cleanPayload.dt = rawProduct.dt || window.currentActiveProduct.title;
      }
      if (rawProduct.iu || window.currentActiveProduct?.featured_image) {
        cleanPayload.iu = rawProduct.iu || window.currentActiveProduct.featured_image;
      }
      if (rawProduct.sku) cleanPayload.sku = rawProduct.sku;
      if (rawProduct.pr) cleanPayload.pr = rawProduct.pr;
      if (rawProduct.vi) cleanPayload.vi = rawProduct.vi;

      return cleanPayload;
    }

    async _saveList() {
      const product = this._cleanProductPayload({
        epi: window.currentActiveVariantId,
        empi: window.currentActiveProduct?.id,
        du: window.currentActiveProduct?.url
      });
      
      const { addToLids, removeFromLids } = this._separateListActions();

      if (addToLids.length > 0) {
        await this._handleListsAction(product, addToLids, 'add');
      }
      
      if (removeFromLids.length > 0) {
        await this._handleListsAction(product, removeFromLids, 'remove');
      }

      let listInputs = this.listsContainer.querySelectorAll('input[type="checkbox"]');
      let isAddedToAtLeastOneList = Array.from(listInputs).some((input) => input.checked);

      if (window.currentActiveWishlistButton) {
        window.currentActiveWishlistButton.updateVisualState(isAddedToAtLeastOneList);
      }

      setTimeout(() => {
        this._hide();
      }, 300);
    }

    async _handleListsAction(product, lids, action) {
      return new Promise((resolve) => {
        const onSuccess = () => {
          if (action === 'add') this._prepareCustomSuccessNotification(lids.length);
          resolve();
        };

        const onError = (error) => {
          console.error('Swym API Error:', error);
          resolve();
        };

        if (action === 'add') {
          const cleanProduct = this._cleanProductPayload(product);
          window._swat.addProductToLists(cleanProduct, lids, onSuccess, onError);
        } else {
          let remaining = lids.length;
          lids.forEach((lid) => {
            const listObj = this.lists ? this.lists.find((l) => l.lid === lid) : null;
            
            const rawTargetItem = listObj && listObj.listcontents 
              ? listObj.listcontents.find((item) => 
                  String(item.epi) === String(product.epi) || String(item.empi) === String(product.empi)
                ) 
              : null;

            // Strip out disallowed DB metadata keys
            const cleanTargetItem = this._cleanProductPayload(rawTargetItem || product);

            const onSingleSuccess = () => {
              remaining--;
              if (remaining === 0) onSuccess();
            };

            if (typeof window._swat.deleteItemFromList === 'function') {
              window._swat.deleteItemFromList(lid, cleanTargetItem, onSingleSuccess, onError);
            } else if (typeof window._swat.deleteProductFromList === 'function') {
              window._swat.deleteProductFromList(lid, cleanTargetItem, onSingleSuccess, onError);
            } else {
              window._swat.removeProductFromLists(cleanTargetItem, [lid], onSingleSuccess, onError);
            }
          });
        }
      });
    }

    _separateListActions() {
      const addToLids = [];
      const removeFromLids = [];
      this.globalActionArray.forEach((listAction) => {
        if (listAction.actionType === 'add') {
          addToLids.push(listAction.listId);
        } else if (listAction.actionType === 'remove') {
          removeFromLids.push(listAction.listId);
        }
      });
      return { addToLids, removeFromLids };
    }

    _validateForm() {
      const listStatus = this._validateField();
      if (!listStatus) return;
      this._createNewList();
    }

    _createNewList() {
      let onSuccess = async () => {
        await this._renderLists();
        this._hideCreateList();
      };
      let onError = (error) => console.error('Error while creating a List', error);
      window._swat.createList(
        {
          lname: this.createListTextField.value.trim(),
        },
        onSuccess,
        onError
      );
    }

    _prepareCustomSuccessNotification(listCount) {
      const title = window.currentActiveProduct?.title || '';
      const image = window.currentActiveProduct?.featured_image || window.currentActiveVariant?.featured_image?.src || '';
      const html = `
        <style>
          .swym-notification-success-inner .swym-image{ display: none !important }
          #swym-custom-notification-content { display: flex; gap: 10px; align-items: center; cursor: pointer }
          #swym-custom-notification-content #swym-custom-image-container { min-height: 50px; min-width: 50px; max-height: 50px; max-width: 50px }
          #swym-custom-notification-content #swym-custom-image-container #swym-custom-image { width: 100%; height: 100%; object-fit: cover; }
          #swym-custom-notification-content #swym-custom-title-container { font-weight: 500; font-size: 14px }
        </style>
        <a id="swym-custom-notification-content" href="/account">
          <div id="swym-custom-image-container">
            <img id="swym-custom-image" src="${image}" alt="wishlist product image"/>
          </div>
          <div id="swym-custom-title-container"><strong>${title}</strong> has been added to <strong>${listCount} ${listCount === 1 ? 'list!' : 'lists!'}</strong></div>
        </a>
      `;
      if (window._swat?.ui?.uiRef?.showSuccessNotification) {
        window._swat.ui.uiRef.showSuccessNotification({ message: `${html}` });
      }
    }

    _validateField() {
      const listName = this.createListTextField.value.trim().toLowerCase();
      let error = { status: false, type: '' };
      if (listName === '') {
        error.status = true;
        error.type = 'isBlank';
      } else if (listName.length < 3) {
        error.status = true;
        error.type = 'isShortString';
      } else if (this.lists && this.lists.find((list) => list.lname.trim().toLowerCase() === listName)) {
        error.status = true;
        error.type = 'isSameListNameString';
      }

      this.createListImagetext.textContent =
        error.status && error.type === 'isBlank' ? 'MW' : this.createListTextField.value.substr(0, 2);

      if (error.status) {
        switch (error.type) {
          case 'isBlank':
            this.createListError.textContent = this.errorStrings.emptyString;
            break;
          case 'isShortString':
            this.createListError.textContent = this.errorStrings.shortString;
            break;
          case 'isSameListNameString':
            this.createListImagetext.textContent = this.createListError.textContent =
              `'${listName}'` + this.errorStrings.sameListString;
            break;
        }
        return false;
      } else {
        this.createListError.textContent = '';
      }
      return true;
    }
  }
  customElements.define('swym-wishlist-popup', SwymWishlistPopup);
}